var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,1v14H1V1H15 M15,0H1C0.45,0,0,0.45,0,1v14c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1V1C16,0.45,15.55,0,15,0L15,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,9.76h-9.5C3.11,9.76,3,9.65,3,9.51V8.99c0-0.14,0.11-0.25,0.25-0.25h9.5c0.14,0,0.25,0.11,0.25,0.25v0.52 C13,9.65,12.89,9.76,12.75,9.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,7.22h-9.5C3.11,7.22,3,7.11,3,6.97V6.45C3,6.31,3.11,6.2,3.25,6.2h9.5C12.89,6.2,13,6.31,13,6.45v0.52 C13,7.11,12.89,7.22,12.75,7.22z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1242_",
    x: 0.43,
    y: 2.96,
    width: 15.15,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,12.32h-9.5C3.11,12.32,3,12.21,3,12.07v-0.52c0-0.14,0.11-0.25,0.25-0.25h9.5c0.14,0,0.25,0.11,0.25,0.25v0.52 C13,12.21,12.89,12.32,12.75,12.32z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/Templates.d11f8cf9fe3c21ac55ce15086940bdd2.svg";
export { ForwardRef as ReactComponent };